import React from 'react';
import PropTypes from 'prop-types';
import { RadioToggle } from 'core/controls';
import { SvgIcon } from 'core/icons';

const normalizedIds = {
  '2RM': '2WD',
  '4RM': '4WD',
  TA: 'FWD',
  TI: 'AWD',
  PA: 'RWD'
};

const DriveTypeIcon = ({ driveType }) => {
  const id = normalizedIds[driveType] || driveType;
  const icon = `single-${id}`.toLowerCase();
  const className = `drive-type-${id}`;

  return (
    <SvgIcon name={icon} className={`drive-type-option__image ${className}`} />
  );
};

const DriveTypeToggle = props => {
  const { options, selections, onChange } = props;

  return (
    <RadioToggle
      className="drive-type-toggle"
      options={options}
      selected={x =>
        x.driveType === selections.driveType &&
        x.rearWheelType === selections.rearWheelType
      }
      onChange={onChange}
      renderLabel={x => (
        <React.Fragment>
          <div>
            <DriveTypeIcon driveType={x.driveType} />
          </div>
          <div>
            <div>{x.driveType}</div>
            <div>{x.rearWheelType}</div>
          </div>
        </React.Fragment>
      )}
    />
  );
};

DriveTypeToggle.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      driveType: PropTypes.string.isRequired,
      rearWheelType: PropTypes.string
    })
  ).isRequired,
  selections: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};

export default DriveTypeToggle;
